import React, { useRef } from "react";
import {
  getRoleAll,
  deleteRole,
  softDeleteRole,
} from "../../Services/RoleService";
import Swal from "sweetalert2";
import MTable from "../../Components/MTable/MTable";
import { InputSwitch } from "primereact/inputswitch";
import { NavLink, useNavigate } from "react-router-dom";
import { uuid } from "../../Utils/Utils";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import EditButton from "../../Components/Button/EditButton";
import DeleteButton from "../../Components/Button/DeleteButton";
import { useSelector } from "react-redux";

const RolePage = () => {
  const navigate = useNavigate();
  const mTable = useRef();
  const { userInfo } = useSelector((state) => state.auth);

  const removeData = (item) => {
    deleteRole(
      item._id,
      (res) => {
        //console.log(res.status);
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Delete data success",
            text: "Data has been deleted!",
          }).then((res) => {
            mTable.current.refresh();
          });
        }
      },
      ({ response: { data } }) => {
        Swal.fire({
          icon: "error",
          title: "Delete data fail",
          text: data.message,
        });
      }
    );
  };

  const onEdit = (item) => () => {
    navigate("edit/" + item._id);
  };

  const onRemove = (item) => () => {
    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: "Deleted data can not be restored!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        removeData(item);
      }
    });
  };

  const columns = [
    { id: uuid(), title: "Role Name", field: "role_name", sortable: true },
    { id: uuid(), title: "Description", field: "description", sortable: true },
    {
      id: uuid(),
      title: "Active",
      field: "is_active",
      render: (item) => {
        if (item.is_active === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "Action",
      style: {
        width: "15%",
      },
      render: (item) => {
        return (
          <div>
            <EditButton title="Edit" onClick={onEdit(item)} />
            <DeleteButton title="Remove" onClick={onRemove(item)} />
          </div>
        );
      },
    },
  ];

  const onAddData = () => {
    navigate("add/new");
  };

  const onActiveChange = (item) => (e) => {
    if (item._id == userInfo.role_id) {
      toastError(
        `${item.role_name} Role is yout role, you can't deactive this role!`
      );
      return;
    }

    const status = e.target.value ? "Activate" : "Inactive";
    softDeleteRole(item._id, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} Success.`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} Failed.`);
      });
  };

  const propsTable = {
    defaultSort: "role_name",
    columns,
    getData: getRoleAll,
    showIndex: true,
    showAddButton: true,
    onAddData,
    enableFilter: true,
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Role User</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Role User</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">
                    <i className="fa fa-address-card" /> Role List
                  </div>
                </div>
                <div className="card-body">
                  <MTable ref={mTable} {...propsTable} />
                </div>
                <div className="card-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RolePage;
